export const GET_RENEWAL_CONFRATIO = 'GET_RENEWAL_CONFRATIO';
export const LEAD_GENERATE_COUNT = 'LEAD_GENERATE_COUNT';
export const LEAD_OPEN_DATA = 'LEAD_OPEN_DATA';
export const GET_ESCALATION_DATA = 'GET_ESCALATION_DATA';
export const RENEWAL_TRACK_SEARCH ='RENEWAL_TRACK_SEARCH'
export const GET_ESCALLATION_LIST='GET_ESCALLATION_LIST';
export const UPDATE_LEAD_OPEN ='UPDATE_LEAD_OPEN'
export const UPDATE_RTM_ESCALLATION ='UPDATE_RTM_ESCALLATION'
export const SEARCH_FILTER_FORM = 'SEARCH_FILTER_FORM'
export const UPDATE_STATUS ='UPDATE_STATUS'


